//
import Model from '@/models/Model'

/**
 * @class
 */
export default class SlGroundSellerCustomerReceivable extends Model {
    /**
     *
     */
    get hr_employee_email() {
        return this.hr_employee ? this.hr_employee.email : '-'
    }

    /**
     *
     */
    get hr_employee_name_case() {
        return this.hr_employee ? this.hr_employee.name_case : '-'
    }

    /**
     *
     */
    get hr_employee_rut() {
        return this.hr_employee ? this.hr_employee.rut : '-'
    }

    /**
     *
     */
    resource() {
        return 'sl_ground_seller/customer_receivable'
    }
}
